import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_date_picker_selector = _resolveComponent("date-picker-selector");
  const _component_date_picker = _resolveComponent("date-picker");
  const _component_dropdown_body = _resolveComponent("dropdown-body");
  const _component_b_dropdown = _resolveComponent("b-dropdown");
  return _openBlock(), _createBlock(_component_b_dropdown, {
    ref: "dropdown",
    "no-caret": "",
    dropstart: "",
    toggleClass: "dropdown-selector",
    class: "date-picker-popup",
    menuClass: "datepicker-menu",
    onHidden: $options.handleHidden,
    onShown: $options.handleShown,
    offset: "8"
  }, {
    "button-content": _withCtx(() => [_createVNode(_component_date_picker_selector, {
      onClick: $options.handleToggle,
      loading: $data.loading,
      selector: $props.datePickerDate?.selector,
      pillStyle: $props.pillStyle,
      dateStyle: {
        color: '#595959',
        fontWeight: 500,
        lineHeight: '12px',
        fontSize: '14px',
        textAlign: 'right'
      }
    }, null, 8, ["onClick", "loading", "selector", "pillStyle"])]),
    default: _withCtx(() => [_createVNode(_component_dropdown_body, null, {
      default: _withCtx(() => [_createVNode(_component_date_picker, {
        ref: "datePicker",
        onCancel: $options.handleDatePickerCanel,
        onSubmit: $options.handleSubmit,
        date: $props.datePickerDate,
        weekType: _ctx.getSystemWeekType,
        selectedPeriod: $props.selectedPeriod,
        onChange: _cache[0] || (_cache[0] = val => _ctx.$emit('change', val)),
        onAfterCustomRefresh: _cache[1] || (_cache[1] = $event => _ctx.$emit('afterCustomRefresh'))
      }, null, 8, ["onCancel", "onSubmit", "date", "weekType", "selectedPeriod"])]),
      _: 1
    })]),
    _: 1
  }, 8, ["onHidden", "onShown"]);
}